export const enum querykeys {
  RESEND_VERIFY_CODE = "RESEND_VERIFY_CODE",
  GET_USER = "GET_USER",

  GET_ALL_PRODUCTS = "GET_ALL_PRODUCTS",
  GET_FEATURED_PRODUCTS = "GET_FEATURED_PRODUCTS",
  GET_RELATED_PRODUCTS = "GET_RELATED_PRODUCTS",
  GET_SINGLE_PRODUCT = "GET_SINGLE_PRODUCT",
  GET_CATEGORIES = "GET_CATEGORIES",
  GET_SUB_CATEGORIES = "GET_SUB_CATEGORIES",
  GET_SUB_SUB_CATEGORIES = "GET_SUB_SUB_CATEGORIES",
  GET_BRANDS = "GET_BRANDS",

  GET_CART_COUNT = "GET_CART_COUNT",
  GET_CART_ITEMS = "GET_CART_ITEMS",

  GET_ADDRESSES = "GET_ADDRESSES",

  GET_ALL_ORDERS = "GET_ALL_ORDERS",
  GET_ALL_RETURNS = "GET_ALL_RETURNS",
  GET_SINGLE_RETURNS = "GET_SINGLE_RETURNS",

}
